(function () {
    const BODY_CLASS_PREFIX = "bc-env";
    const MAX_ATTEMPTS = 40;
    const ATTEMPT_DELAY = 150;
    const BANNER_HEIGHT = 18; // px

    function markEnvironment(envType, envColor) {
        // 1. Find the Frappe Sticky Navbar Wrapper
        const stickyWrapper = document.querySelector('.sticky-top');
        
        // Safety: If the navbar hasn't rendered yet, return false so we can retry
        if (!stickyWrapper) return false;

        if (!document.body) return false;

        const bodyClass = `${BODY_CLASS_PREFIX}-${envType.toLowerCase()}`;
        document.body.classList.add(BODY_CLASS_PREFIX, bodyClass);

        let banner = document.getElementById("bc-env-banner");
        if (!banner) {
            banner = document.createElement("div");
            banner.id = "bc-env-banner";
            
            // --- KEY FIX 1: INSERT INSIDE THE STICKY WRAPPER ---
            // This forces the banner and the navbar to move as one single unit.
            stickyWrapper.prepend(banner);
            
            // --- KEY FIX 2: FORCE VERTICAL STACKING ---
            // We ensure the sticky wrapper stacks the banner on top of the navbar.
            stickyWrapper.style.display = "flex";
            stickyWrapper.style.flexDirection = "column";
            stickyWrapper.style.transition = "none"; // Prevent jumpy animations
        }

        const background = envColor || (envType === "Staging" ? "#ea580c" : "#dc2626");
        banner.textContent = `${envType.toUpperCase()} ENVIRONMENT`;
        banner.style.background = background;
        
        // Styling the banner text directly for safety
        banner.style.color = "#fff";
        banner.style.fontSize = "11px";
        banner.style.fontWeight = "700";
        banner.style.textAlign = "center";
        banner.style.height = `${BANNER_HEIGHT}px`;
        banner.style.lineHeight = `${BANNER_HEIGHT}px`; // Vertically center text
        
        // --- KEY FIX 3: UPDATE FRAPPE GLOBAL POSITIONING ---
        // 46px (Default Navbar) + 18px (Your Banner) = 64px
        // This tells the Page Header (R00002) exactly where to stick so it doesn't overlap.
        document.documentElement.style.setProperty('--navbar-height', '64px', 'important');

        return true;
    }

    function getEnvironmentConfig() {
        if (window.frappe && frappe.boot?.brand_club_environment) {
            const config = frappe.boot.brand_club_environment;
            const enabled = Boolean(config.development_environment);
            const type = config.environment_type || "Development";
            const color = config.environment_color || "";
            return { enabled, type, color };
        }
        return { enabled: false };
    }

    function waitForBootAndApply(attempt = 0) {
        const config = getEnvironmentConfig();

        if (config.enabled && config.type) {
            const success = markEnvironment(config.type, config.color);
            if (success) return; 
        }

        if (attempt >= MAX_ATTEMPTS) {
            console.warn("Brand Club Environment Banner - Max attempts reached");
            return;
        }

        window.setTimeout(() => waitForBootAndApply(attempt + 1), ATTEMPT_DELAY);
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => waitForBootAndApply());
    } else {
        waitForBootAndApply();
    }
})();